import { defineStore } from 'pinia';
import { Export, ExportRepo } from '@fibl/zdb-common';
import { getI18n } from '@/util/i18n';
import * as OxsExportRepo from '@/repository/export';

export const useExportStore = defineStore('export', {
	state: () => ({
		currentJob: null as { id: string } | null,
		jobPromise: null as Promise<Export.Job> | null,
		jobLatest: null as Export.Job | null,
		startTime: 0,
		lastUpdate: 0,
	}),

	persist: {
		paths: ['currentJob', 'startTime'],
	},

	getters: {
		progress(): Export.Job {
			if (!this.jobLatest) return {} as Export.Job;
			return this.jobLatest;
		},
		elapsed(): number {
			return this.lastUpdate - this.startTime;
		},
		rate(): number {
			let p = this.jobLatest?.stats.processed || 0;
			let el = this.elapsed > 1000 ? this.elapsed / 1000 : 1;
			return p / el;
		},
		eta(): number {
			const rate = this.rate;
			if (rate <= 0) return 0;
			let rem =
				(this.jobLatest?.stats.estimated || 1) - (this.jobLatest?.stats.processed || 0);
			return rem / rate;
		},
		statusOpts() {
			const i18n = getI18n();
			return [
				{
					value: 'available',
					label: i18n.t('stores.available'),
				},
				{
					value: 'unavailable',
					label: i18n.t('stores.unavailable'),
				},
				{
					value: 'archived',
					label: i18n.t('stores.archived'),
				},
			];
		},
	},

	actions: {
		async createRequestKomReport(params: OxsExportRepo.RequestKomParams) {
			const jobId = await OxsExportRepo.createRequestKomReport(params);
			this.currentJob = { id: jobId } as any;
			return this.tryContinue()!;

		},
		async runJob(params: Export.CreateJobParams) {
			if (params.config.length !== 36) {
				let tpl = await ExportRepo.getConfig({ alias: params.config });
				params.config = tpl.id;
			}
			this.currentJob = await ExportRepo.createJob(params);
			return this.tryContinue()!;
		},

		tryContinue(jobId?: string) {
			if (!this.currentJob) return;
			this.startTime = Date.now();
			const started = this.startTime;
			this.jobPromise = ExportRepo.pollUntilJobComplete(
				jobId ? jobId : this.currentJob!.id,
				1000,
				1000 * 60 * 20,
				(update: Export.Job) => {
					if (started !== this.startTime || !this.currentJob) return;
					console.log(update);
					this.jobLatest = update;
					this.lastUpdate = Date.now();
				},
			);
			return this.jobPromise!;
		},

		resetJob() {
			this.currentJob = null;
			this.jobPromise = null;
		},

		async loadLastJob() {
			try {
				if (!this.currentJob?.id) return;
				let jobId = this.currentJob.id;
				let job = (await ExportRepo.getJob({ id: jobId })) as Export.Job;
				if (['running', 'queued'].includes(job!.status)) {
					this.tryContinue(job.id);
				}
			} catch (e) {
				console.log('cannot load last job', e);
			}
		},
	},
});
